// 引入api
import { fun_PostAction,fun_GetAction } from "@/api";
import { mapState } from "vuex";
import router from "../../../router/router";
import Layout from "../../layout/Home.vue"; //Layout 是架构组件，不在后台返回，在文件里单独引入
import store from "../../../store";
// 引入时间格式转换方法
import { formatDate } from "@/utils/validate.js";
import VueRouter from 'vue-router';
export default {
  data() {
    return {
      // 消息提醒加载
      msgLoading: false,
      // 路由
      otherRouters: [],
      // 我的招标项目
      myProject: "（我的招标项目）",
      // 切换身份
      identityList: [
        {
          src: require("@/assets/images/workbench/tenderer_tit_icon.png"),
          name: "招标人/采购单位",
          type: "201904241041160002"

        },
        {
          src: require("@/assets/images/workbench/bidder_tit_icon.png"),
          name: "投标人/供应商",
          type: "201904241343420001"
        },
        {
          src: require("@/assets/images/workbench/agent_tit_icon.png"),
          name: "招标代理/采购代理",
          type: "201904241346560059"
        },
      ],
      // 当前身份
      identityObj: {},
      // 正在进行的项目
      ongoingProject: [],
      // 用户信息完整度
      userMessageList: [],
      // 待办事项一览
      pendingList: [],
      // 消息提醒所有数据
      msgList: [],
      // 消息提醒展示数据
      msgShowList: [],
      // tabs默认值
      activeName: "first",
      // 列表loading状态
      loading: false,
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        tenderPrjName: null, // 招标项目名称
        registrationId: null, // 招标登记编号
      },
      // 招标公告
      projectList: [],
      // 登录角色
      loginType: sessionStorage.getItem("loginType"),
      // 招标公告、我的项目请求url
      url: null,
      // 显示内容的日期数组
      specialDates: [],
      // 当前日期
      currentDate: new Date(),
      animate: false,
      timer: null
    };
  },
  created() {
    // 添加对 sessionStorage 的监听
    window.addEventListener("setItem", () => {
      // 遍历
      this.identityList.map(e=>{
        // 判断
        if(e.type === sessionStorage.getItem("loginType")){
          // 获取当前身份
          this.identityObj = e;
        }
      })
    });
  },
  // 注册组件
  components: {
  },
  computed: {
    ...mapState(["isQueryHome"]),
    noMore () {
      return this.msgShowList.length === this.msgList.length;
    },
    disabled () {
      return this.msgLoading || this.noMore;
    }
  },
  watch: {
    // 监听路由对象中的'$route'属性
    '$route': 'getPath',
    isQueryHome(val, v) {
      if (val) {
        // 获取登录角色
        this.loginType = sessionStorage.getItem("loginType");
        // 如果是投标人
        if(sessionStorage.getItem("loginType") == "201904241343420001"){
          // 选中招标公告
          this.activeName = "second";
        }else{
          // 选中我的项目
          this.activeName = "first";
        }
        // 查询页面方法
        this.fun_GetList();
      }
    },
    // 监听日历
    currentDate: {
      handler(newVal, objVal) {
        if(newVal){
          // 获取数据
          this.fun_GetBidOpeningCalender(formatDate(newVal, "yyyy-MM"));
          this.currentDate = newVal;
        }
      },
    }
  },
  // 模板编译完成
  mounted() {
    // 遍历
    this.identityList.map(e=>{
      // 判断
      if(e.type === sessionStorage.getItem("loginType")){
        // 获取当前身份
        this.identityObj = e;
      }
    })
    // 查询页面方法
    this.fun_GetList();
    this.scrollUp(); // 开启滚动效果
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    /**
     * 消息提醒更多跳转
     */
    fun_GetMore(){
      // 跳转消息提醒
      this.$router.push({
        path: "/workbenchMore",
        // 携带参数主键和状态
        query: {  }
      });
    },
    /**
     * 监听路由传参
     * @param to 当前传递的参数
     * @param from 上一个传递的参数
     */
    getPath(to, from){
      // 判断
      if(to.path === "/home" && to.query.type){
        // 查询页面方法
        this.fun_GetList();
      }
    },
    // 滚动
    scrollUp() {
      this.timer = setInterval(() => {
        this.animate = true; // 向上滚动的时候需要添加动画
        setTimeout(() => {
          this.ongoingProject.push(this.ongoingProject[0]); // 将数组的第一个元素添加到数组最后一个
          this.ongoingProject.shift(); // 删除数组的第一个元素
          this.animate = false;
        }, 500);
      }, 2000);
    },
    //鼠标移上去停止
    stop() {
      clearInterval(this.timer);
    },
    //鼠标离开继续
    up() {
      this.scrollUp();
    },
    /**
     * 查询页面方法
     */
    fun_GetList(){
      // 如果是投标人
      if(sessionStorage.getItem("loginType") == "201904241343420001"){
        this.url = "/tenderHome/noticeList";
        this.activeName = "second";
      }
      // 如果是招标人或者招标代理
      else{
        this.url = "/tenderHome/myProjectTenderList";
        this.activeName = "first";
      }
      // 获取用户信息完整度表格
      this.fun_GetUserMessageList();
      // 获取待办表格
      this.fun_GetPendingList();
      // 获取招标公告表单
      this.fun_NoticeList();
      // 获取开标日历项目信息
      this.fun_GetBidOpeningCalender(formatDate(new Date(), "yyyy-MM"));
      // 获取消息提示
      this.fun_GetMessageReminding();
    },
    /**
     * 获取用户信息完整度表格数据
     * @author 付翔
     */
    fun_GetUserMessageList() {
      // 请求，获取结果集
      fun_PostAction("/tenderHome/userMessageList").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 回显table
          this.userMessageList = data;
        }
      });
    },
    /**
     * 获取待办一览表格数据
     * @author 付翔
     */
    fun_GetPendingList() {
      // 请求，获取结果集
      fun_PostAction("/tenderHome/pendingList").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 回显table
          this.pendingList = data;
        }
      });
    },
    /**
     * 进入待办详情
     * @param e
     */
    fun_GetPendingDetail(e){
      // 跳转详情页面
      this.$router.push({path: e.url, query: { id: e.id, type: e.type }});
    },
    /**
     * 进入招标公告详情
     * @param e
     */
    fun_GetTendererNotice(e){
      // 跳转详情页面
      this.$router.push({
        path: "/tendererNoticeDetail",
        // 操作类型
        query: {
          id: e.id,
          isTenderSignature: e.tenderSignedState ? "1" : "",
          type: "detail"
        }
      });
    },
    /**
     * 正在进行中的项目
     */
    fun_ProceedNotice(){
      try {
        // 请求，获取结果集
        fun_PostAction("/tenderHome/proceedNotice", { }).then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 判断请求是否成功
          if (result) {
            // 回显table
            this.ongoingProject = data;
            // 关闭loadingS
            this.loading = false;
          }
        });
      } catch {
      }
    },
    /**
     * 查询招标公告项目信息
     */
    fun_NoticeList(){
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        fun_PostAction(this.url, {
          ...this.form,
        }).then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 判断请求是否成功
          if (result) {
            // 解构data
            const { total, records } = data;
            // 回显table
            this.projectList = records;
            // 获取分页总条数
            this.total = total;
            // 关闭loading
            this.loading = false;
          }
        });
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_NoticeList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_NoticeList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_NoticeList();
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Detail(e) {
      // 菜单编号
      let menuCode = "";
      // 投标标记
      let biddingMark = "K2";
      // 资格预审标识声明
      let versionF2 = e.prequalificationTypeNo;
      // 联合体标志
      let isUnionCorpEnrollNo = e.isUnionCorpEnrollNo;
      // 如果是邀请招标
      if(e.tenderTypeNumNo == 'F2'){
        versionF2 = "H0";
        biddingMark = "K0";
      }
      // 如果是投标人
      if(sessionStorage.getItem("loginType") == "201904241343420001"){
        // 拼接
        menuCode = e.tenderTypeNumNo + versionF2 + isUnionCorpEnrollNo + e.oldFlagNo;
      }
      // 如果是招标人或者代理
      else{
        // 如果招标登记编号不为空
        if(e.registrationId){
          // 如果是招标人
          if(sessionStorage.getItem("loginType") == "201904241041160002"){
            // 如果是新项目
            if(e.oldFlagNo){
              // 拼接
              menuCode = e.constructionFlag + e.tenderMethodNo + e.tenderTypeNumNo + versionF2  + e.oldFlagNo;
            }else{
              // 拼接
              menuCode = e.constructionFlag + e.applicationNo + e.tenderMethodNo + e.tenderTypeNumNo + e.isUnionTenderNo + versionF2;
            }
          }
          // 如果是招标代理
          else if(sessionStorage.getItem("loginType") == "201904241346560059"){
            // 如果是新项目
            if(e.oldFlagNo){
              // 拼接
              menuCode = e.tenderMethodNo + e.tenderTypeNumNo + versionF2 + e.oldFlagNo;
            }else{
              // 拼接
              menuCode = e.tenderTypeNumNo + e.isUnionTenderNo + versionF2;
            }
          }
        }
        // 如果招标登记编号为空
        else{
          // 如果是招标人
          if(sessionStorage.getItem("loginType") == "201904241041160002"){
            // 拼接
            menuCode = e.constructionIdNo + e.agencyCorpRecordNo + "X1";
          }
          // 如果是招标代理
          else if(sessionStorage.getItem("loginType") == "201904241346560059"){
            // 拼接
            menuCode = e.agencyCorpRecordNo + "X1";
          }
        }
      }
      // 请求，获取结果集
      fun_PostAction("/tenderHome/projectTrackingDetail", {
        unionAgreementId: e.unionAgreementId, // 联合体编号
        tenderReference: e.tenderReference, // 招标编号
        announcementId: e.id, // 招标公告编号
        registrationId: e.registrationId, // 招标登记编号
        agencyCorpRecordId: e.agencyCorpRecordId, // 招标备案编号
        constructionId: e.constructionId, // 报建编号
        powerId: sessionStorage.getItem("loginType"),// 用户登录类型
        menuCode: menuCode,// 菜单编号
        biddingMark: biddingMark,// 投标标记
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取路由
          var dataRouters = JSON.parse(data);
          // 遍历数据
          dataRouters.map(e=>{
            // 转成数值
            e.order = Number(e.order);
          })
          // 存储路由
          sessionStorage.setItem("workbenchRouters", JSON.stringify(dataRouters));
          // Layout组件特殊处理
          dataRouters = [
            {
              component: "Layout",
              path: "/workbenchRouters",
              children: [ ...dataRouters ]
            }
          ]
          // 存储用于判断显示菜单
          sessionStorage.setItem("workbenchMenu", "1");
          // 处理路由
          this.routerGo(dataRouters);
          // 如果是详情
          if (JSON.parse(data)[0].path.indexOf("Detail") !== -1) {
            // 默认跳转第一个
            this.$router.push({path: JSON.parse(data)[0].path, query: { id: "", controllerFlg: "detail", projectScheduleNum: Number(e.projectScheduleNum) }});
          }else{
            // 默认跳转第一个
            this.$router.push({path: JSON.parse(data)[0].path, query: { projectScheduleNum: Number(e.projectScheduleNum) }});
          }
        }
      });
    },
    /**
     * 切换方法
     */
    fun_GetActiveTab(key,val){
      // 切换
      this.projectActive = val;
    },
    /**
     * 跳转地址
     */
    fun_GetPath(){
      // 请求，获取结果集
      fun_PostAction("/tenderHome/checkTenderInfo", { }).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 跳转
          window.open(msg, '_blank');
        }
      });
    },
    handleMonthChange(date) {
      // 当日历视图变化时（即点击下一月），这个方法会被调用
      console.log('New month:', date);
      // 你可以在这里执行你需要的操作
    },
    /**
     * 判断是否当天
     * @param date
     */
    fun_IsToDay(date){
      // 获取当天
      const toDay = new Date();
      return(
          date.getDate() === toDay.getDate() && // 比较日
          date.getMonth() === toDay.getMonth() && // 比较月
          date.getFullYear() === toDay.getFullYear() // 比较年
      );
    },
    /**
     * CA检测弹窗
     */
    fun_GetCADetection(){
      // 打开弹窗
      this.$refs.caDetection.dialogVisible = true;
    },
    /**
     * tabs切换
     * @param e 切换的值
     */
    fun_HandleClick(e) {
      // 如果是投标人
      if(sessionStorage.getItem("loginType") == "201904241343420001"){
        // 请求我的项目
        if (e.index === "0") {
          this.url = "/tenderHome/myProjectTenderList";
          this.activeName = "first";
        }
        // 请求可参与投标项目
        else if (e.index === "1") {
          this.url = "/tenderHome/noticeList";
          this.activeName = "second";
        }
      }
      // 如果是招标人或者招标代理
      else{
        this.url = "/tenderHome/myProjectTenderList";
        this.activeName = "first";
      }
      // 请求招标公告、我的项目一览
      this.fun_NoticeList();
    },
    /**
    * 获取开标日历项目信息
    * @author 滕威
    */
    fun_GetBidOpeningCalender(date) {
      try {
        // 请求，获取结果集
        fun_PostAction("/tenderHome/bidOpeningCalender", {
          date: date
        }).then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 判断请求是否成功
          if (result) {
            if (data) {
              // 统计数据总数
              this.specialDates = data;
            }
          }
        });
      } catch {
        this.$message.error("服务器错误，请反馈给管理员")
      }
    },
    /**
     * 当前日期是否有项目
     */
    fun_GetDateContent(date) {
      let arr = [];
      // 遍历
      for(const key in this.specialDates) {
        // 根据日期匹配
        if (key === date) {
          // 获取当前日期的项目
          arr = this.specialDates[key];
        }
      }
      if (arr && arr.length > 0) {
        // 返回项目
        return arr ? arr : '';
      }
    },
    /**
     * 日历组件不补0
     */
    fun_GetDay(value) {
      const day = value.split("-")[2]; // 11, 02
      return day.startsWith("0") ? day.slice(1) : day;
    },
    /**
     * 消息提醒
     */
    fun_GetMessageReminding(){
      try {

      } catch {
        this.$message.error("服务器错误，请反馈给管理员")
      }
    },
    /**
     * 消息提醒滚动
     */
    fun_GetMsgLoad(){
      // 修改状态
      this.msgLoading = true;
      // 延迟获取数据
      setTimeout(() => {
        // 获取数据
        this.msgShowList.push(...this.msgList.slice(this.msgShowList.length, this.msgShowList.length + 10));
        this.msgLoading = false;
      }, 1000)
    },
    /**
     * 消息提醒跳转
     */
    fun_GetMessageRemindingPath(e){
      // 跳转详情页面
      this.$router.push({path: e});
    },
    routerGo(routerJson) {
      this.filterOtherRouter(routerJson);
      let asyncRouters = this.filterAsyncRouter(routerJson);
      const localouter = [
        // 工作台详情
        {
          path: "/workbenchDetails",
          name: "workbenchDetails",
          component: () => import("../../../views/page/workbench/details/index.vue")
        },
        // 修改密码
        {
          path: "/password",
          name: "password",
          component: () => import("../../../views/page/userRegister/updatePassword/index.vue")
        },
        // 修改密码
        {
          path: "/loginPassword",
          name: "loginPassword",
          component: () => import("../../../views/page/corpView/loginPassword/index.vue")
        },
        // 交易人 - 用户注册模块
        {
          path: "/userRegister",
          name: "userRegister",
          component: () => import("../../../views/page/userRegister/index.vue")
        },
        // 网上CA资料申报信息
        {
          path: "/userDeclare",
          name: "userDeclare",
          component: () => import("../../../views/page/userRegister/declare/index.vue")
        },
        // 企业登记详情
        {
          path: "/corpRegistrationDetails",
          name: "corpRegistrationDetails",
          component: () => import("../../../views/page/userRegister/corpRegistration/details/index.vue")
        },
        // 消息提醒
        {
          path: "/workbenchMore",
          name: "workbenchMore",
          component: () => import("../../../views/page/workbench/components/more/index.vue")
        },
      ];
      const homeRouter = [
        {
          path: "/home",
          name: "home",
          component: () => import("../../../views/layout/Home.vue"),
          // redirect: { path: "/userManage" },
          children: [...this.otherRouters, ...localouter]
        }
      ];
      // router.addRoutes([...homeRouter,...asyncRouters]); //动态添加路由
      // router.addRoutes(asyncRouters); //动态添加路由
      router.matcher = new VueRouter({
        routes: [...homeRouter,...asyncRouters]
      }).matcher
      global.antRouter = asyncRouters; //将路由数据传递给全局变量，做侧边栏菜单渲染工作
    },

    filterAsyncRouter(asyncRouterMap) {
      //遍历后台传来的路由字符串，转换为组件对象
      const accessedRouters = asyncRouterMap.filter(route => {
        if (route.component) {
          if (route.component === "Layout") {
            //Layout组件特殊处理
            route.component = Layout;
          } else {
            route.component = this.componentImport(route.component);
          }
        }
        if (route.children && route.children.length) {
          route.children = this.filterAsyncRouter(route.children);
        }
        return true;
      });
      return accessedRouters;
    },

    filterOtherRouter(asyncRouterMap) {
      for (let i in asyncRouterMap) {
        let otherRouter = {};
        if (asyncRouterMap[i].component) {
          if (asyncRouterMap[i].component === "Layout") {
            //Layout组件特殊处理
          } else {
            otherRouter.name = asyncRouterMap[i].name.replace(
                asyncRouterMap[i].name,
                asyncRouterMap[i].name + "Detail"
            );
            otherRouter.path = asyncRouterMap[i].path.replace(
                asyncRouterMap[i].path,
                asyncRouterMap[i].path + "Detail"
            );
            otherRouter.meta = {};
            if (asyncRouterMap[i].title != "") {
              otherRouter.title = asyncRouterMap[i].title + "详情";
              otherRouter.component = this.componentImport(
                  asyncRouterMap[i].component.replace(
                      asyncRouterMap[i].path.replace("Ebd", ""),
                      asyncRouterMap[i].path.replace("Ebd", "") + "/details"
                  )
              );
            }
          }
        }
        if (otherRouter.name) {
          this.otherRouters.push(otherRouter);
        }
        if (asyncRouterMap[i].children && asyncRouterMap[i].children.length) {
          asyncRouterMap[i].children = this.filterOtherRouter(
              asyncRouterMap[i].children
          );
        }
      }
      return asyncRouterMap;
    },
    componentImport(component) {
      return () => import("../../../views/" + component);
    },
  }
};
